export const VehicleType = {
  Car: 1,
  Truck: 2,
  SUV: 3,
  Van: 4,
  Other: 5,
  Motorcycle: 6,
  ATV: 7,
};

export const VehicleTypeMap = {
  [VehicleType.Car]: "Car",
  [VehicleType.Truck]: "Truck",
  [VehicleType.SUV]: "SUV",
  [VehicleType.Van]: "Van",
  [VehicleType.Motorcycle]: "Motorcycle",
  [VehicleType.ATV]: "ATV/UTV",
  [VehicleType.Other]: "Other",
};

export const VehicleColor = {
  Beige: 1,
  Black: 2,
  Blue: 3,
  Brown: 4,
  Gray: 5,
  Green: 6,
  LightBlue: 7,
  Orange: 8,
  Red: 9,
  Silver: 10,
  White: 11,
  Yellow: 12,
  Other: 13,
};

export const VehicleColorMap = {
  [VehicleColor.Beige]: "Beige",
  [VehicleColor.Black]: "Black",
  [VehicleColor.Blue]: "Blue",
  [VehicleColor.Brown]: "Brown",
  [VehicleColor.Gray]: "Gray",
  [VehicleColor.Green]: "Green",
  [VehicleColor.LightBlue]: "Light Blue",
  [VehicleColor.Orange]: "Orange",
  [VehicleColor.Red]: "Red",
  [VehicleColor.Silver]: "Silver",
  [VehicleColor.White]: "White",
  [VehicleColor.Yellow]: "Yellow",
  [VehicleColor.Other]: "Other",
};

export const DamageSide = {
  Front: 1,
  Rear: 2,
  DriverSide: 3,
  PassengerSide: 4,
};

export const DamageSideMap = {
  [DamageSide.Front]: "Front",
  [DamageSide.Rear]: "Rear",
  [DamageSide.DriverSide]: "DriverSide",
  [DamageSide.PassengerSide]: "PassengerSide",
};

export const DamageSeverity = {
  None: 1,
  Scratch: 2,
  Crack: 3,
  Dent: 4,
  Gouge: 5,
};

export const DamageSeverityMap = {
  [DamageSeverity.None]: "None",
  [DamageSeverity.Scratch]: "Scratch",
  [DamageSeverity.Crack]: "Crack",
  [DamageSeverity.Dent]: "Dent",
  [DamageSeverity.Gouge]: "Gouge",
};
